export enum EAuthActionType {
    saveToken = 'SAVE_TOKEN',
    removeToken = 'REMOVE_TOKEN',
}
